import {Table, TableHeader, TableColumn, TableBody, Pagination, Spinner, Button} from "@nextui-org/react";
import { saveAs } from "file-saver";
import { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";

export default function ClientTablePagination({ data, isLoading, header, content }) {
    const [page, setPage] = useState(1);
    const pages = Math.max(1, Math.ceil((data?.length || 0) / 5));

    const items = useMemo(() => {
        const start = (page - 1) * 5;
        const end = start + 5;

        return data?.slice(start, end);
    }, [page, data]);
    
    useEffect(() => {
        if(data?.message){
            toast.error(data?.message)
        }
    })

    const exportToCSV = () => {
        if (!data || data.length === 0) {
            toast.error("Tidak ada data untuk diekspor.");
            return;
        }

        const csvHeader = header.join(",");
        const csvRows = data.map((row) => header.map((col) => row[col] || "").join(","));
        const csvContent = [csvHeader, ...csvRows].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, "exported_data.csv");
    };

    return (
        <Table 
            className="overflow-x-auto overflow-y-hidden"
            aria-label="table"
            removeWrapper
            bottomContent={
                <div className="flex w-full justify-between px-3">
                    <Button
                        size="sm"
                        color="primary"
                        onClick={exportToCSV}
                    >
                        Export CSV
                    </Button>
                    <Pagination
                        isCompact
                        showControls
                        showShadow
                        color="primary"
                        page={page}
                        total={pages}
                        onChange={(page) => setPage(page)}
                    />
                    
                </div>
                
            }
        >
            <TableHeader>
                { header.map((item) => <TableColumn key={item}>{item}</TableColumn>) }
            </TableHeader>
            <TableBody loadingContent={<Spinner />} loadingState={isLoading ? 'loading' : 'idle'} emptyContent="Tidak ada data">
                {items?.map((item, index) => content(item, index))}
            </TableBody>
        </Table>
    );
}
